import { Component, OnInit } from '@angular/core';
import { Params } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserApiService } from 'src/app/core/services/api/user-api.service';
import { UserActivityLog } from 'src/app/shared/models/user-activity-log.model';

@Component({
  selector: 'app-user-activity-log-dialog',
  templateUrl: './user-activity-log-dialog.component.html',
  styleUrls: ['./user-activity-log-dialog.component.scss'],
})
export class UserActivityLogDialogComponent implements OnInit {
  userId!: number;
  logs: UserActivityLog[] = [];
  isLoading = false;
  totalItems: number = 0;
  error: string | null = null;

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private userApi: UserApiService
  ) {}

  ngOnInit(): void {
    this.userId = this.config.data.userId;
    this.fetchLogs();
  }

  fetchLogs(params: Params = {}): void {
    this.isLoading = true;
    this.userApi.getUserActivity(this.userId, params).subscribe({
      next: (res: any) => {
        this.logs = res.data || [];
        this.totalItems = res.meta.total;
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to load user activity logs.';
        this.isLoading = false;
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
